export default {
  WEB_TITLE: 'Camera lobby view - Private Project.',

  // App Keys
  APP_LANG: 'APP.LANGUAGE',
  APP_AUTH: 'APP.Authentication',
  APP_USER: 'APP.UserInfo',
  APP_API : (process.env.NODE_ENV !== 'production')
    ? `http://${location.hostname}:8000/api`
    : `${location.origin}/api`
}